import { addEvent, addViewEvent, initTelemetry, telemetryLogin, telemetryLogout } from '@creditornot/browser-telemetry';

import { initTelemetryViewEvents } from 'common/hooks/useTelemetryViewEvent';
import sendErrorReport from 'common/utils/sendErrorReport';

import { CustomDestination, EventNameValueType, LogTypeValueType } from '../../avo/Avo';

type EventProperties = {
  log_type: Exclude<LogTypeValueType, 'performance' | 'result'>;
  view?: string;
  attributes?: Record<string, any>;
  event_name: EventNameValueType;
  duration_ms?: number;
};

type ViewEventProperties = {
  duration_ms: number;
  attributes?: Record<string, any>;
};

export const Gatekeeper: CustomDestination = {
  make: (): void => {
    // Register our visibility listeners before browser-telemetry's, to ensure we get the events first
    initTelemetryViewEvents(error => sendErrorReport(error, 'gatekeeper'));
    initTelemetry({
      appVersion: process.env.APP_REVISION,
      disabled: false,
      endpoint: process.env.GATEKEEPER_MERCHANT_SERVICE_URI,
      hasUserConsent: true, // As this is b2b application, user consent defaults to true.
      logging: false,
      requestHeaders: process.env.GATEKEEPER_API_KEY
        ? {
            'x-api-key': process.env.GATEKEEPER_API_KEY,
          }
        : undefined,
    });
  },
  logEvent: (_: string, eventProperties: EventProperties): void => {
    const { duration_ms, log_type, view, event_name, ...otherEventProperties } = eventProperties;
    addEvent({
      log_type,
      view,
      event_name,
      attributes: otherEventProperties,
      duration_ms,
    });
  },

  // @args (userId: string, userProperties: object)
  setUserProperties: (): void => {
    // Set user properties
  },
  identify: (userId: string): void => {
    telemetryLogin(userId);
  },
  unidentify: (): void => {
    telemetryLogout();
  },
  logPage: (pageName: string, eventProperties: ViewEventProperties): void => {
    const { duration_ms, ...otherEventProperties } = eventProperties;
    addViewEvent(pageName, duration_ms || 0, otherEventProperties);
  },

  // @args (amount: number, eventProperties: object)
  revenue: (): void => {
    // Track Revenue
  },
};
